import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "children"];
import React from 'react';
import { Header as SemanticUiHeader } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { ChildrenPropType } from '../../../../services/proptypes';
import useSemanticUiProps from '../../hooks/use-semantic-ui-props/use-semantic-ui-props';
var defaultProps = {
  content: null,
  children: null
};
export default function Header(_ref) {
  var content = _ref.content,
    children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getHeaderProps = _useSemanticUiProps.getHeaderProps;
  if (_isEmpty(content) && _isEmpty(children)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SemanticUiHeader, _extends({
    content: content
  }, getHeaderProps(restProps)), children);
}
Header.defaultProps = defaultProps;